/**
 * Left-hand column of a single BO comment row: renders the original
 * (read-only) comment with paragraph/line-break formatting preserved.
 *
 * @module busniessOffice/components/singleComment/OriginalCommentPanel
 */

import React from "react";
import { renderTextWithProperIndentation } from "./utils/renderTextWithProperIndentation";

interface OriginalCommentPanelProps {
  originalComment: string;
  containerRef: React.RefObject<HTMLDivElement>;
}

const OriginalCommentPanel = ({
  originalComment,
  containerRef,
}: OriginalCommentPanelProps) => {
  return (
    <div
      className="single-comment-original flex-1 overflow-auto rounded-md bg-primaryGray-16 p-3 text-h12 font-normal"
      ref={containerRef}
    >
      {renderTextWithProperIndentation(originalComment)}
    </div>
  );
};

export default OriginalCommentPanel;
